/**
 * Drupal behaviour: turns each .carousel-wrap into an Embla carousel.
 * - Arrows, dots, swipe all work.
 * - The whole control bar hides if scrolling isn't needed.
 *
 * Needs once.js (core) and EmblaCarousel (added in the theme library).
 */
(function (Drupal, once) {
  Drupal.behaviors.teaserSlider = {
    attach(context) {
      // Process every carousel exactly once per page load.
      once('teaserSlider', '.carousel-wrap', context).forEach((wrapper) => {
        const emblaRoot = wrapper.querySelector('.embla');
        if (!emblaRoot) {
          return; // safety check
        }

        /* ---------- element grabs ---------- */
        const viewport = emblaRoot.querySelector('.embla__viewport');
        const prevBtn = wrapper.querySelector('.embla__prev');
        const nextBtn = wrapper.querySelector('.embla__next');
        const dotsWrap = wrapper.querySelector('.embla__dots');
        const controls = wrapper.querySelector('.embla__controls'); // arrows + dots (+ play btn)

        /* ---------- Embla init ---------- */
        const embla = EmblaCarousel(viewport, {
          loop: false,
          align: 'start',
          containScroll: 'trimSnaps',
          slidesToScroll: 1,
        });

        /* ---------- arrows ---------- */
        prevBtn?.addEventListener('click', () => embla.scrollPrev());
        nextBtn?.addEventListener('click', () => embla.scrollNext());

        const toggleArrows = () => {
          if (!prevBtn || !nextBtn) return;
          prevBtn.disabled = !embla.canScrollPrev();
          nextBtn.disabled = !embla.canScrollNext();
        };

        /* ---------- dots ---------- */
        if (dotsWrap) {
          embla.scrollSnapList().forEach((_, i) => {
            const dot = document.createElement('button');
            dot.className = 'embla__dot';
            dot.type = 'button';
            dot.addEventListener('click', () => embla.scrollTo(i));
            dotsWrap.appendChild(dot);
          });
        }

        const toggleDots = () => {
          if (!dotsWrap) return;
          const idx = embla.selectedScrollSnap();
          [...dotsWrap.children].forEach((d, i) =>
            d.classList.toggle('is-selected', i === idx)
          );
        };

        /* ---------- hide/show control bar ---------- */
        const updateControlsVisibility = () => {
          if (!controls) return;

          const needBar = embla.canScrollPrev() || embla.canScrollNext();

          // Show controls only when scrolling is possible
          controls.style.display = needBar ? '' : 'none';
        };

        /* ---------- initial run ---------- */
        toggleArrows();
        toggleDots();
        updateControlsVisibility();

        /* ---------- Embla event hooks ---------- */
        embla.on('select', () => {
          toggleArrows();
          toggleDots();
        });

        embla.on('reInit', () => {
          toggleArrows();
          toggleDots();
          updateControlsVisibility();
        });
      });
    },
  };
})(Drupal, once);
